import { render } from "./CompletionAssignmentList.vue?vue&type=template&id=30ca5925&scoped=true"
import script from "./CompletionAssignmentList.vue?vue&type=script&lang=js"
export * from "./CompletionAssignmentList.vue?vue&type=script&lang=js"

import "./CompletionAssignmentList.vue?vue&type=style&index=0&id=30ca5925&scoped=true&lang=scss"

import exportComponent from "/voc/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30ca5925"]])

export default __exports__